<script>
  import * as THREE from "three";
  import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
  // import { PointerLockControls } from "three/examples/jsm/controls/PointerLockControls.js";
  import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
  import { MeshoptDecoder } from "meshoptimizer";

  import { onMount } from "svelte";

  import { width, height, cardState, videoState, loadedObjects } from "./stores";

  import howler from "howler";

  import Card from "./Card.svelte";
  import Video from "./Video.svelte";

  let sceneLoadedObjects = 0;

  let musicSound = new Howl({
    src: [
      "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/HoliznaCC0%20-%20Dreamers.mp3?v=1654682781464"
    ],
    preload: true,
    volume: 0.8,
    loop: true
  });

  // let height = vh * 100;
  // let width = vw * 100;

  let widthValue;
  width.subscribe(value => {
    widthValue = value;
  });
  let heightValue;
  height.subscribe(value => {
    heightValue = value;
  });

  let appCanvas;

  export const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(
    75,
    widthValue / heightValue,
    0.1,
    2000
  );
  let renderer;
  let orbitControls;
  // camera.position.z = 25;

  let controls;
  let card;

  let loader;
  let raycasterNegY;
  let raycasterPosY;
  let raycasterNegZ;
  let raycasterPosZ;
  let raycasterNegX;
  let raycasterPosX;
  //an array for raycaster
  let raycastObjects = [];
  let raycastedObject;
  let raycaster;
  let mouse = new THREE.Vector2();

  // console.log(GLTFLoader, MeshoptDecoder);

  let sizes = {
    width: widthValue,
    height: heightValue
  };

  let sunColor = {
    color: "#e8f8ff",
    intensity: 1
  };
  let skyColor = {
    color: "#c9e4ff",
    groundColor: "blue"
  };

  let fogColor = {
    color: "#c3a9c4"
  };

  let backgroundColor = {
    color: "rgb(196,225,255)"
    // color: "#feecff"
    // color: "#69b9ff"
  };

  let particlesColor = {
    // color: "#00FFFF"
    color: "rgb(196, 225, 255)"
  };

  let alienCubesLightColor = {
    color: "#00FFFF"
  };

  scene.background = new THREE.Color(backgroundColor.color);

  const bgloader = new THREE.CubeTextureLoader();
  let map = bgloader.load([
    "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/desert2_px_1.jpg?v=1669043261448",
    "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/desert2_nx_1.jpg?v=1669043262542",
    "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/desert2_py.jpg?v=1663062056098",
    "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/desert2_ny_1.jpg?v=1669043263133",
    "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/desert2_pz_1.jpg?v=1669043261973",
    "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/desert2_nz_1.jpg?v=1669043260807"
  ]);
  //scene.background = map;
  scene.environment = map;

  const skylight = new THREE.HemisphereLight(
    skyColor.color,
    skyColor.groundColor,
    1.95
  );
  scene.add(skylight);

  let pointLight = new THREE.PointLight("blue", 2, 10);
  pointLight.position.set(0, 100, 0);
  scene.add(pointLight);
  let pointLight2 = new THREE.PointLight("#2b92ff", 2, 10);
  pointLight.position.set(0, 200, -150);
  scene.add(pointLight2);

  const skyGeometry = new THREE.SphereGeometry(700, 25, 25);
  const materialGreen = new THREE.MeshBasicMaterial({ color: 0x00ff00 });

  var uniforms = {
    color: { type: "c", value: new THREE.Color(0x00ff00) },
    lightPos: { type: "v3", value: new THREE.Vector3(0, 0, 0) },
    range: { type: "f", value: 2 }
  };

  const skyMaterial = new THREE.ShaderMaterial({
    //uniforms:       uniforms,
    side: THREE.DoubleSide,
    transparent: false,
    fog: false,
    // wireframe: true,
    vertexShader: `
                              varying vec2 vUvs;
                               void main() {	
                              vec4 localPosition = vec4(position, 1.0);

                              gl_Position = projectionMatrix * modelViewMatrix * localPosition;
                              vUvs = uv;
                            }
                              `,
    fragmentShader: `
                              varying vec2 vUvs;
                              uniform vec2 resolution;
  
                              void main() {
                              vec3 color = vec3(0.0);
                              vec3 lower = vec3(0.77, 0.88, 1.0);
                              //vec3 upper = vec3(0.1, 0.1, 0.25);
                              vec3 upper = vec3(0.2, 0.43, 0.68);
                              //color = vec3(step(0.5, mod(vUvs.y * 10.0, 0.75)));
                              //color = vec3(step(0.5, vUvs.y));
                              //color = vec3(smoothstep(0.25, 1.0, vUvs.y));
                              color = vec3(mix(lower, upper, smoothstep(0.45, 0.75, vUvs.y)));
                              gl_FragColor = vec4(color, 1.0);
                            }
                              `
  });

  const sky = new THREE.Mesh(skyGeometry, skyMaterial);
  scene.add(sky);

  const planetGeom = new THREE.SphereGeometry(40, 50, 50);
  const planetMat = new THREE.ShaderMaterial({
    //uniforms:       uniforms,
    side: THREE.DoubleSide,
    transparent: false,
    fog: false,
    // wireframe: true,
    vertexShader: `
                              varying vec2 vUvs;
                               void main() {	
                              vec4 localPosition = vec4(position, 1.0);

                              gl_Position = projectionMatrix * modelViewMatrix * localPosition;
                              vUvs = uv;
                            }
                              `,
    fragmentShader: `
                              varying vec2 vUvs;
                              uniform vec2 resolution;
  
                              void main() {
                              vec3 color = vec3(0.0);
                              vec3 lower = vec3(0.77, 0.88, 1.0);
                              //vec3 upper = vec3(0.1, 0.1, 0.25);
                              vec3 upper = vec3(0.2, 0.43, 0.68);
                              //color = vec3(step(0.5, mod(vUvs.y * 10.0, 0.75)));
                              //color = vec3(step(0.5, vUvs.y));
                              //color = vec3(smoothstep(0.25, 1.0, vUvs.y));
                              color = vec3(mix(lower, upper, smoothstep(0.15, 0.95, vUvs.y)));
                              gl_FragColor = vec4(color, 1.0);
                            }
                              `
  });
  const planet1 = new THREE.Mesh(planetGeom, planetMat);
  planet1.position.set(586, 87, -155);

  const planet2 = new THREE.Mesh(planetGeom, planetMat);
  planet2.position.set(586, 87, 125);
  planet2.scale.set(2.5, 2.5, 2.5);

  const planet3 = new THREE.Mesh(planetGeom, planetMat);
  planet3.position.set(-540, 175, -175);
  planet3.scale.set(2.5, 2.5, 2.5);

  scene.add(planet1, planet2, planet3);

  let objects = [];

  let forestScene;

  function createForestScene(x, y, z) {
    loader.load(
      // "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/duospace_c.glb?v=1654679488195",
      // "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/duospace2_c.glb?v=1654680301238",
      // "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/duospace3_c.glb?v=1654681704012",
      // "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/scene_c.glb?v=1663275279088",
      "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/duospace_scene_min_c.glb?v=1669022291073",
      function(gltf) {
        forestScene = gltf.scene;
        forestScene.position.set(x, y, z);
        forestScene.children[0].children[1].material.color = new THREE.Color(
          "#c9e4ff"
        );
        forestScene.children[0].children[3].visible = false;

        gltf.scene.traverse(function(child) {
          if (child.isMesh) {
            child.name = "CA";
            objects.push(child);
          }
        });
        scene.add(forestScene);
      },
      // called while loading is progressing
      function(xhr) {
        console.log((xhr.loaded / xhr.total) * 100 + "% loaded scene");
        if ((xhr.loaded / xhr.total) * 100 > 99.9) {
          sceneLoadedObjects++;
          console.log(sceneLoadedObjects);
          loadedObjects.set(sceneLoadedObjects);
        }
      }
    );
  }

  let stands;
  function loadStands(x, y, z) {
    loader.load(
      "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/stands_c.glb?v=1663273517466",
      function(gltf) {
        stands = gltf.scene;
        stands.position.set(x, y, z);
        scene.add(stands);
      },
      // called while loading is progressing
      function(xhr) {
        console.log((xhr.loaded / xhr.total) * 100 + "% loaded scene");
        if ((xhr.loaded / xhr.total) * 100 > 99.9) {
          sceneLoadedObjects++;
          console.log(sceneLoadedObjects);
          loadedObjects.set(sceneLoadedObjects);
        }
      }
    );
  }

  const material = new THREE.ShaderMaterial({
    // uniforms:       uniforms,
    //transparent: true,
    // wireframe: true,
    vertexShader: `
                                                                                  varying vec2 vUvs;
                                                                                  void main() {	
                                                                                  vec4 localPosition = vec4(position, 1.0);

                                                                                  gl_Position = projectionMatrix * modelViewMatrix * localPosition;
                                                                                  vUvs = uv;
                                                                                  }
                                                                                  `,
    fragmentShader: `
                                                                                  varying vec2 vUvs;
                                                                                  uniform vec2 resolution;

                                                                                  void main() {
                                                                                  vec3 color = vec3(1.0, 0.0, 0.0);
                                                                                  //color = vec3(step(0.5, vUvs.y));
                                                                                  color = vec3(step(0.25, mod(vUvs.y * 100.0, 1.0)));
                                                                                  gl_FragColor = vec4(color, 1.0);
                                                                                  }
                                                                                  `
  });

  let light;
  function loadLight(x, y, z) {
    loader.load(
      //"https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/light_c.glb?v=1660994417968",
      "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/light_uv_c.glb?v=1663269724600",
      function(gltf) {
        light = gltf.scene;
        light.position.set(x, y, z);
        light.children[0].material = new THREE.MeshStandardMaterial({
          color: "rgb(50,110,173)"
        });
        //console.log(material)
        return scene.add(light);
      },
      // called while loading is progressing
      function(xhr) {
        console.log((xhr.loaded / xhr.total) * 100 + "% loaded light");
        if ((xhr.loaded / xhr.total) * 100 > 99.9) {
          sceneLoadedObjects++;
          console.log(sceneLoadedObjects);
          loadedObjects.set(sceneLoadedObjects);
        }
      }
    );
  }

  let manequin1;
  function loadManequin(x, y, z) {
    let light = new THREE.PointLight("#2b92ff", 2, 15);
    light.position.set(x + 1, y + 2, z + 1);
    let light2 = new THREE.PointLight("#2bedff", 2, 15);
    light.position.set(x - 0, y + 2, z + 0);
    loader.load(
      "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/menequin_silver_c.glb?v=1660988007178",
      function(gltf) {
        manequin1 = gltf.scene;
        manequin1.position.set(x, y, z);
        manequin1.scale.set(2.5, 2.5, 2.5);
        manequin1.children[0].children[2].material.metalness = 0.75;
        manequin1.children[0].children[2].material.roughness = 0.25;
        //console.log(manequin.children[0].children[2]);
        return scene.add(manequin1, light, light2);
      },
      // called while loading is progressing
      function(xhr) {
        console.log((xhr.loaded / xhr.total) * 100 + "% loaded manequin1");
        if ((xhr.loaded / xhr.total) * 100 > 99.9) {
          sceneLoadedObjects++;
          console.log(sceneLoadedObjects);
          loadedObjects.set(sceneLoadedObjects);
        }
      }
    );
  }

  let manequin2;

  const pointsMaterial = new THREE.PointsMaterial({
    color: "#3bf3d1",
    blending: THREE.AdditiveBlending
  });
  pointsMaterial.size = 0.5;
  pointsMaterial.sizeAttenuation = true;
  pointsMaterial.transparent = true;

  function loadManequin2(x, y, z) {
    let light = new THREE.PointLight("cyan", 1.5, 30);
    light.position.set(x + 1, y + 2, z + 1);
    let light2 = new THREE.PointLight("blue", 1.5, 30);
    light.position.set(x - 1, y + 2, z + 1);
    loader.load(
      "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/menequin_silver_2_c.glb?v=1660989440710",
      function(gltf) {
        manequin2 = gltf.scene;

        let points = new THREE.Points(
          manequin2.children[0].children[2].geometry,
          pointsMaterial
        );
        manequin2.position.set(x, y, z);
        points.position.set(x, y, z);
        manequin2.scale.set(1.5, 1.5, 1.5);
        manequin2.children[0].children[2].material.metalness = 0.95;
        manequin2.children[0].children[2].material.roughness = 0.25;
        //console.log(manequin.children[0].children[2]);
        console.log(manequin2.children[0].children[2].geometry, points);
        return scene.add(points, manequin2, light, light2);
      },
      // called while loading is progressing
      function(xhr) {
        console.log((xhr.loaded / xhr.total) * 100 + "% loaded manequin2");
        if ((xhr.loaded / xhr.total) * 100 > 99.9) {
          sceneLoadedObjects++;
          console.log(sceneLoadedObjects);
          loadedObjects.set(sceneLoadedObjects);
        }
      }
    );
  }

  let videoPanel, video, videoTexture;

  function loadVideoPanel(x, y, z) {
    let geom = new THREE.BoxGeometry(0.05, 2.88, 5.12);
    let material = new THREE.MeshStandardMaterial({ map: videoTexture });
    let videoPanel = new THREE.Mesh(geom, material);
    videoPanel.position.set(x, y, z);
    return scene.add(videoPanel);
  }

  let bags;
  function loadBags(x, y, z) {
    let light = new THREE.PointLight("cyan", 1.5, 30);
    light.position.set(x + 1, y + 2, z + 1);
    let light2 = new THREE.PointLight("blue", 1.5, 30);
    light.position.set(x - 1, y + 2, z + 1);
    loader.load(
      "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/bags_c.glb?v=1660993385103",
      function(gltf) {
        bags = gltf.scene;
        bags.position.set(x, y, z);
        return scene.add(bags, light, light2);
      },
      // called while loading is progressing
      function(xhr) {
        console.log((xhr.loaded / xhr.total) * 100 + "% loaded bags");
        if ((xhr.loaded / xhr.total) * 100 > 99.9) {
          sceneLoadedObjects++;
          console.log(sceneLoadedObjects);
          loadedObjects.set(sceneLoadedObjects);
        }
      }
    );
  }

  let mixer;
  let whalebot = new THREE.Object3D();
  function loadWhalebot() {
    let objectURL =
      "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/duo_whalebot_c.glb?v=1666709033669";
    // Load a glTF resource
    loader.load(
      // resource URL
      objectURL,
      // called when the resource is loaded
      function(gltf) {
        whalebot = gltf.scene;
        // console.log(whalebot);
        // whalebot.children[0].material = new THREE.MeshStandardMaterial({
        //   color: "black"
        // });
        whalebot.rotateY(Math.PI / 2);
        whalebot.scale.set(5, 5, 5);
        whalebot.position.set(0, 110, 0);
        //whalebot.children[0].castShadow = true;
        scene.add(whalebot);

        mixer = new THREE.AnimationMixer(whalebot);
        mixer.clipAction(gltf.animations[0]).play();
        const clips = gltf.animations;
      },
      // called while loading is progressing
      function(xhr) {
        console.log((xhr.loaded / xhr.total) * 100 + "% loaded whale");
        if ((xhr.loaded / xhr.total) * 100 > 99.9) {
          sceneLoadedObjects++;
          console.log(sceneLoadedObjects);
          loadedObjects.set(sceneLoadedObjects);
        }
      }
    );
  }

  let twoManequins;
  function loadTwoManequins(x, y, z) {
    let light = new THREE.PointLight("cyan", 2.0, 30);
    light.position.set(x + 1, y + 2, z + 1);
    let light2 = new THREE.PointLight("blue", 2.0, 30);
    light.position.set(x - 1, y + 2, z + 1);
    loader.load(
      "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/two_manequins_c.glb?v=1660996679784",
      function(gltf) {
        twoManequins = gltf.scene;
        twoManequins.position.set(x, y, z);
        // twoManequins.children[0].children[2].material.metalness = 0.95;
        // twoManequins.children[0].children[2].material.roughness = 0.25;
        return scene.add(twoManequins, light, light2);
      },
      // called while loading is progressing
      function(xhr) {
        console.log((xhr.loaded / xhr.total) * 100 + "% loaded twoManequins");
        if ((xhr.loaded / xhr.total) * 100 > 99.9) {
          sceneLoadedObjects++;
          console.log(sceneLoadedObjects);
          loadedObjects.set(sceneLoadedObjects);
        }
      }
    );
  }

  let words;
  function loadWords(x, y, z) {
    loader.load(
      "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/words_c.glb?v=1663252437408",
      function(gltf) {
        words = gltf.scene;
        words.position.set(x, y, z);
        return scene.add(words);
      },
      // called while loading is progressing
      function(xhr) {
        console.log((xhr.loaded / xhr.total) * 100 + "% loaded words");
        if ((xhr.loaded / xhr.total) * 100 > 99.9) {
          sceneLoadedObjects++;
          console.log(sceneLoadedObjects);
          loadedObjects.set(sceneLoadedObjects);
        }
      }
    );
  }

  let bodyParts;
  function loadBodyParts(x, y, z) {
    loader.load(
      "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/bodyPart2_c.glb?v=1663271114777",
      function(gltf) {
        bodyParts = gltf.scene;
        bodyParts.position.set(x, y, z);
        return scene.add(bodyParts);
      },
      // called while loading is progressing
      function(xhr) {
        console.log((xhr.loaded / xhr.total) * 100 + "% loaded bodyParts");
        if ((xhr.loaded / xhr.total) * 100 > 99.9) {
          sceneLoadedObjects++;
          console.log(sceneLoadedObjects);
          loadedObjects.set(sceneLoadedObjects);
        }
      }
    );
  }

  let logo;
  function loadLogo(x, y, z) {
    loader.load(
      "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/logo2_c.glb?v=1663253872879",
      function(gltf) {
        logo = gltf.scene;
        logo.position.set(x, y, z);
        return scene.add(logo);
      },
      // called while loading is progressing
      function(xhr) {
        console.log((xhr.loaded / xhr.total) * 100 + "% loaded logo");
        if ((xhr.loaded / xhr.total) * 100 > 99.9) {
          sceneLoadedObjects++;
          console.log(sceneLoadedObjects);
          loadedObjects.set(sceneLoadedObjects);
        }
      }
    );
  }

  let imageCubes;
  function loadImageCubes(x, y, z) {
    loader.load(
      "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/imageCubes3_c.glb?v=1663274241830",
      function(gltf) {
        imageCubes = gltf.scene;
        imageCubes.position.set(x, y, z);
        return scene.add(imageCubes);
      },
      // called while loading is progressing
      function(xhr) {
        console.log((xhr.loaded / xhr.total) * 100 + "% loaded imageCubes");
        if ((xhr.loaded / xhr.total) * 100 > 99.9) {
          sceneLoadedObjects++;
          console.log(sceneLoadedObjects);
          loadedObjects.set(sceneLoadedObjects);
        }
      }
    );
  }

  function loadArrow(x, y, z, rotY, name) {
    loader.load(
      "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/arrow.glb?v=1663578450292",
      function(gltf) {
        // imageCubes = gltf.scene;
        gltf.scene.position.set(x, y, z);
        gltf.scene.rotation.set(0, rotY, 0);
        gltf.scene.children[0].name = name;
        gltf.scene.children[0].material.color = new THREE.Color("black");
        raycastObjects.push(gltf.scene.children[0]);
        return scene.add(gltf.scene);
      },
      // called while loading is progressing
      function(xhr) {
        console.log((xhr.loaded / xhr.total) * 100 + "% loaded imageCubes");
        if ((xhr.loaded / xhr.total) * 100 > 99.9) {
          sceneLoadedObjects++;
          console.log(sceneLoadedObjects);
          loadedObjects.set(sceneLoadedObjects);
        }
      }
    );
  }

  function loadPlus(x, y, z, rotY, name) {
    loader.load(
      "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/plus.glb?v=1663879509434",
      function(gltf) {
        // imageCubes = gltf.scene;
        gltf.scene.position.set(x, y, z);
        gltf.scene.rotation.set(0, rotY, 0);
        gltf.scene.scale.set(0.25, 0.25, 0.25);
        gltf.scene.children[0].name = name;
        gltf.scene.children[0].material.color = new THREE.Color("black");
        raycastObjects.push(gltf.scene.children[0]);
        return scene.add(gltf.scene);
      },
      // called while loading is progressing
      function(xhr) {
        console.log((xhr.loaded / xhr.total) * 100 + "% loaded imageCubes");
        if ((xhr.loaded / xhr.total) * 100 > 99.9) {
          sceneLoadedObjects++;
          console.log(sceneLoadedObjects);
          loadedObjects.set(sceneLoadedObjects);
        }
      }
    );
  }

  // let skySphere;
  // function loadSkySphere(x, y, z) {
  //   loader.load(
  //     "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/skySphere.glb?v=1663063081048",
  //     function(gltf) {
  //       skySphere = gltf.scene;
  //       skySphere.children[0].material.fog = false;
  //       skySphere.position.set(x, y, z);
  //       return scene.add(skySphere);
  //     },
  //     // called while loading is progressing
  //     function(xhr) {
  //       console.log((xhr.loaded / xhr.total) * 100 + "% loaded skySphere");
  //       if ((xhr.loaded / xhr.total) * 100 > 99) {
  //         sceneLoadedObjects++;
  //         loadedObjects.set(sceneLoadedObjects);
  //       }
  //     }
  //   );
  // }

  let speed = 0;
  let velocity = 0;
  let gravity = 0.0055;
  let jumpState = false;

  const groundPlaneGeometry = new THREE.PlaneGeometry(1000, 1000);
  const groundPlaneMaterial = new THREE.MeshStandardMaterial({
    color: "rgb(200,200,220)"
  });
  const groundPlane = new THREE.Mesh(groundPlaneGeometry, groundPlaneMaterial);
  groundPlane.rotation.x = -Math.PI / 2;
  objects.push(groundPlane);
  // scene.add(groundPlane);

  // Particles
  const particlesGeometry = new THREE.BufferGeometry();
  const count = 1500;

  let positions = new Float32Array(count * 3); // Multiply by 3 because each position is composed of 3 values (x, y, z)

  for (
    let i = 0;
    i < count * 3;
    i += 3 // Multiply by 3 for same reason
  ) {
    let num = Math.random();
    positions[i] = Math.cos(num * 360) * 250 * Math.random(); // Math.random() - 0.5 to have a random value between -0.5 and +0.5
    positions[i + 1] = num * 290;
    positions[i + 2] = Math.sin(num * 360) * 250 * Math.random();
  }

  particlesGeometry.setAttribute(
    "position",
    new THREE.BufferAttribute(positions, 3)
  ); // Create the Three.js BufferAttribute and specify that each information is composed of 3 values
  const particlesMaterial = new THREE.PointsMaterial({
    color: particlesColor.color
  });
  particlesMaterial.size = 0.2;
  particlesMaterial.sizeAttenuation = true;
  particlesMaterial.transparent = true;
  // particlesMaterial.depthWrite = true
  particlesMaterial.blending = THREE.AdditiveBlending;

  // Points
  const particles = new THREE.Points(particlesGeometry, particlesMaterial);
  particles.position.set(0, 0, 0);
  scene.add(particles);

  function updateParticles() {
    for (let i = 0; i < count * 3; i += 3) {
      positions[i] += Math.sin(positions[i + 1]) * 0.01;
      positions[i + 1] += 0.04;
      positions[i + 2] += Math.cos(positions[i + 1]) * 0.01;

      if (positions[i + 1] > 290) {
        positions[i + 1] = 0;
      }
    }

    particlesGeometry.setAttribute(
      "position",
      new THREE.BufferAttribute(positions, 3)
    );
  }

  let mouseY = 0;
  function handlePointerMove() {
    mouseY = -(event.clientY / renderer.domElement.clientHeight) * 2 + 1.2;
  }

  let delta;
  let time = Date.now();
  let cameraOffset = new THREE.Vector3();
  let cameraOffsetMultiplier = 2;
  let cameraYAddition = 1;
  let imageCubesSpeed = 0.0002;

  const animate = () => {
    const currentTime = Date.now();
    const delta = currentTime - time;
    time = currentTime;
    let t = 1.0 - Math.pow(0.001, delta);

    requestAnimationFrame(animate);
    updateParticles();

    if (manequin1) {
      manequin1.rotateY(0.001 * delta);
    }
    if (manequin2) {
      manequin2.rotateY(0.001 * delta);
    }
    if (bags) {
      bags.rotateY(0.0001 * delta);
      bags.rotateX(0.0001 * delta);
      bags.rotateZ(0.0001 * delta);
    }
    if (twoManequins) {
      twoManequins.rotateY(0.001 * delta);
    }
    if (words) {
      words.rotateY(0.0001 * delta);
    }
    if (logo) {
      logo.rotateY(0.001 * delta);
    }

    raycast();

    // if (imageCubes) {
    //   imageCubes.translateY(imageCubesSpeed * delta);
    //   if (imageCubes.position.y > 1 || imageCubes.position.y < 0) {
    //     imageCubesSpeed = -imageCubesSpeed;
    //   }
    // }

    if (mixer) {
      mixer.update(delta * 0.001);
    }

    renderer.render(scene, camera);
  };

  const resize = () => {
    renderer.setSize(widthValue, heightValue);
    camera.aspect = widthValue / heightValue;
    camera.updateProjectionMatrix();
  };

  const createScene = el => {
    renderer = new THREE.WebGLRenderer({ antialias: true, canvas: el });
    renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.setPixelRatio(window.devicePixelRatio);

    loader = new GLTFLoader();
    loader.setMeshoptDecoder(MeshoptDecoder);

    orbitControls = new OrbitControls(camera, renderer.domElement);
    orbitControls.target = new THREE.Vector3(0, 0, -1);
    orbitControls.enableDamping = true;
    orbitControls.dampingFactor = 0.95;
    orbitControls.enabled = true;
    orbitControls.enableRotate = true;
    orbitControls.enablePan = false;
    orbitControls.enableZoom = true;
    orbitControls.maxDistance = 200;
    orbitControls.minDistance = 1;
    orbitControls.maxPolarAngle = Math.PI;
    orbitControls.minPolarAngle = 0.3;
    // orbitControls.maxPolarAngle = Math.PI / 2;

    camera.position.set(-262, 5.5, 0);
    orbitControls.target.set(-261, 5.6, 0);
    console.log(orbitControls.object.position);
    orbitControls.update();

    // controls = new PointerLockControls(camera, document.body);
    // card = document.getElementById("card");
    // button.addEventListener("click", () => {
    //   controls.lock();
    //   card.style.display = "none";
    //   musicSound.play();
    // });
    // // controls.lock();
    // // controls.addEventListener("change", () => console.log("Controls Change"));
    // controls.addEventListener("unlock", () => {
    //   card.style.display = "block";
    //   musicSound.pause();
    // });

    // raycasterNegY = new THREE.Raycaster();
    // raycasterPosY = new THREE.Raycaster();
    // raycasterNegZ = new THREE.Raycaster();
    // raycasterPosZ = new THREE.Raycaster();
    // raycasterNegX = new THREE.Raycaster();
    // raycasterPosX = new THREE.Raycaster();

    raycaster = new THREE.Raycaster();

    video = document.getElementById("video");

    videoTexture = new THREE.VideoTexture(video);

    video.addEventListener("progress", function() {
      if (this.buffered.length > 0) {
        let loadedPercentage = this.buffered.end(0) / this.duration;
        console.log(loadedPercentage + "of video");
      }
    });

    createForestScene(0, 0, 0);
    // loadLight(0, 0, 0);
    // loadWords(0, 0, 0);
    // loadLogo(7.4, 59, 7.4);
    // loadBodyParts(0, 0, 0);
    // loadImageCubes(0, 0, 0);
    //loadSkySphere(0, 0, 0);

    loadManequin(0, 1.0, -0.0);
    // loadManequin2(0, 39.0, 9.0);
    // loadVideoPanel(14, 79, 0);
    // loadBags(8.7, 99, -8.7);
    loadWhalebot();
    // loadTwoManequins(-9.2, 132.65, -9.2);

    // loadStands(0, 0, 0);

    loadArrow(-250, 0, 0, 0, "arrow-01");
    loadArrow(-2.5, 0, 0, Math.PI, "arrow-10");
    // loadArrow(0, 0, 2.5, -Math.PI / 2, "arrow-12");
    // loadArrow(-2.8, 20, 2.8, Math.PI / 4, "arrow-21");
    // loadArrow(-6.2, 20, 6.2, (-Math.PI * 3) / 4, "arrow-23");
    // loadArrow(-2.4, 39, 9, Math.PI, "arrow-32");
    // loadArrow(2.4, 39, 9, 0, "arrow-34");
    // loadArrow(5.6, 58, 9, (-Math.PI * 3) / 4, "arrow-43");
    // loadArrow(9.3, 58, 5.6, Math.PI / 4, "arrow-45");
    // loadArrow(11.6, 76, 2.5, -Math.PI / 2, "arrow-54");
    // loadArrow(11.6, 76, -2.5, Math.PI / 2, "arrow-56");
    // loadArrow(6.7, 94, -10, (Math.PI * 3) / 4, "arrow-67");
    // loadArrow(10.0, 94, -6.7, -Math.PI / 4, "arrow-65");
    // loadArrow(2.5, 113.8, -12.5, 0, "arrow-76");
    // loadArrow(-2.5, 113.8, -12.5, -Math.PI, "arrow-78");
    // loadArrow(-7.2, 132.5, -11.1, (Math.PI * 1) / 4, "arrow-87");
    // loadArrow(-11, 132.5, -7.2, (-Math.PI * 3) / 4, "arrow-89");
    // loadArrow(-13, 151.4, -2.5, Math.PI / 2, "arrow-98");

    loadPlus(0, 9.0, 2.5, Math.PI, "plus-1");
    // loadPlus(-6.2, 26, 3.3, -Math.PI / 4, "plus-2");
    // loadPlus(-7.6, 24, 6.3, -Math.PI / 4, "plus-3");
    // loadPlus(-3.4, 25, 1.6, -Math.PI / 4, "plus-4");
    // loadPlus(-1.0, 43, 9, Math.PI / 2, "plus-5");
    // loadPlus(11.5, 78.5, -2.4, 0, "plus-6");
    // loadPlus(11.5, 78.5, 2.4, 0, "plus-7");

    scene.fog = new THREE.FogExp2(backgroundColor.color, 0.002);

    resize();
    animate();
  };

  window.addEventListener("resize", resize);

  onMount(() => {
    createScene(appCanvas);
    window.addEventListener("resize", resize);
    window.addEventListener("click", function() {
      video.play();
      if (!musicSound.playing()) {
        musicSound.play();
      }
    });
    // document.addEventListener("keydown", handleKeydown);
    // document.addEventListener("keyup", handleKeyup);
    // document.addEventListener("pointermove", handlePointerMove);
    appCanvas.addEventListener("pointermove", function(event) {
      event.preventDefault();
      mouse.x = (event.offsetX / window.innerWidth) * 2 - 1;
      mouse.y = -(event.offsetY / window.innerHeight) * 2 + 1;
    });
    appCanvas.addEventListener("pointerdown", function(event) {
      event.preventDefault();
      mouse.x = (event.offsetX / window.innerWidth) * 2 - 1;
      mouse.y = -(event.offsetY / window.innerHeight) * 2 + 1;
      if (!musicSound.playing()) {
        musicSound.play();
      }
    });
    appCanvas.addEventListener("pointerup", function(event) {
      event.preventDefault();
      moveCamera(raycastedObject);
      showCard(raycastedObject);
    });
  });

  function raycast() {
    raycaster.setFromCamera(mouse, camera);
    let intersects = raycaster.intersectObjects(raycastObjects);
    if (intersects.length > 0) {
      intersects[0].object.material.color = new THREE.Color("rgb(50, 110, 173)");
      intersects[0].object.scale.set(1.3, 1.3, 1.3);
      document.documentElement.style.cursor = "pointer";
      raycastedObject = intersects[0].object.name;
    } else {
      for (let i = 0; i < raycastObjects.length; i++) {
        raycastObjects[i].material.color = new THREE.Color("black");
        raycastObjects[i].scale.set(1, 1, 1);
        document.documentElement.style.cursor = "auto";
        raycastedObject = "";
      }
    }
  }

  let levelNumber = 0;
  let buttonBackgroundColor = "rgba(255, 255, 255, 0.2)";
  let buttonTextColor = "cyan";
  let btn0, btn1, btn2, btn3, btn4, btn5, btn6, btn7, btn8, btn9;
  let btn0class = "selectedButton",
    btn1class = "button",
    btn2class = "button",
    btn3class = "button",
    btn4class = "button",
    btn5class = "button",
    btn6class = "button",
    btn7class = "button",
    btn8class = "button",
    btn9class = "button";

  function updateLevelNumber() {
    if (!musicSound.playing()) {
      musicSound.play();
    }

    levelNumber = this.innerHTML;
    if (levelNumber == 0) {
      camera.position.set(-65, 5.5, 0);
      orbitControls.target.set(-64, 5.6, 0);
      orbitControls.update();

      btn0class = "selectedButton";
      btn1class = "button";
      btn2class = "button";
      btn3class = "button";
      btn4class = "button";
      btn5class = "button";
      btn6class = "button";
      btn7class = "button";
      btn8class = "button";
      btn9class = "button";
    }
    if (levelNumber == 1) {
      camera.position.set(0, 3.8, 5);
      orbitControls.target.set(0, 3.8, 0);
      orbitControls.update();

      btn0class = "button";
      btn1class = "selectedButton";
      btn2class = "button";
      btn3class = "button";
      btn4class = "button";
      btn5class = "button";
      btn6class = "button";
      btn7class = "button";
      btn8class = "button";
      btn9class = "button";
    }
    if (levelNumber == 2) {
      camera.position.set(-2, 22.5, 7.5);
      orbitControls.target.set(-3.5, 22.5, 6.0);
      orbitControls.update();

      btn0class = "button";
      btn1class = "button";
      btn2class = "selectedButton";
      btn3class = "button";
      btn4class = "button";
      btn5class = "button";
      btn6class = "button";
      btn7class = "button";
      btn8class = "button";
      btn9class = "button";
    }
    if (levelNumber == 3) {
      camera.position.set(-3.5, 40.5, 9);
      orbitControls.target.set(-3.4, 40.5, 9);
      orbitControls.update();

      btn0class = "button";
      btn1class = "button";
      btn2class = "button";
      btn3class = "selectedButton";
      btn4class = "button";
      btn5class = "button";
      btn6class = "button";
      btn7class = "button";
      btn8class = "button";
      btn9class = "button";
    }
    if (levelNumber == 4) {
      camera.position.set(2.4, 59.25, 7.4);
      orbitControls.target.set(7.5, 59.25, 7.4);
      orbitControls.update();

      btn0class = "button";
      btn1class = "button";
      btn2class = "button";
      btn3class = "button";
      btn4class = "selectedButton";
      btn5class = "button";
      btn6class = "button";
      btn7class = "button";
      btn8class = "button";
      btn9class = "button";
    }
    if (levelNumber == 5) {
      camera.position.set(8.5, 78, 0);
      orbitControls.target.set(8.6, 78, 0);
      orbitControls.update();

      btn0class = "button";
      btn1class = "button";
      btn2class = "button";
      btn3class = "button";
      btn4class = "button";
      btn5class = "selectedButton";
      btn6class = "button";
      btn7class = "button";
      btn8class = "button";
      btn9class = "button";
    }
    if (levelNumber == 6) {
      camera.position.set(6, 96.75, -6);
      orbitControls.target.set(6.5, 96.75, -6.5);
      orbitControls.update();

      btn0class = "button";
      btn1class = "button";
      btn2class = "button";
      btn3class = "button";
      btn4class = "button";
      btn5class = "button";
      btn6class = "selectedButton";
      btn7class = "button";
      btn8class = "button";
      btn9class = "button";
    }
    if (levelNumber == 7) {
      camera.position.set(0, 115, -12.7);
      orbitControls.target.set(-0.5, 115, -12.7);
      orbitControls.update();

      btn0class = "button";
      btn1class = "button";
      btn2class = "button";
      btn3class = "button";
      btn4class = "button";
      btn5class = "button";
      btn6class = "button";
      btn7class = "selectedButton";
      btn8class = "button";
      btn9class = "button";
    }
    if (levelNumber == 8) {
      camera.position.set(-6.2, 134.25, -6.2);
      orbitControls.target.set(-9.2, 134.25, -9.2);
      orbitControls.update();

      btn0class = "button";
      btn1class = "button";
      btn2class = "button";
      btn3class = "button";
      btn4class = "button";
      btn5class = "button";
      btn6class = "button";
      btn7class = "button";
      btn8class = "selectedButton";
      btn9class = "button";
    }
    if (levelNumber == 9) {
      camera.position.set(-13, 153, 0);
      orbitControls.target.set(-13.2, 154, 0);
      orbitControls.update();

      btn0class = "button";
      btn1class = "button";
      btn2class = "button";
      btn3class = "button";
      btn4class = "button";
      btn5class = "button";
      btn6class = "button";
      btn7class = "button";
      btn8class = "button";
      btn9class = "selectedButton";
    }
  }

  function moveCamera(name) {
    if (name == "arrow-10") {
      camera.position.set(-262, 5.5, 0);
      orbitControls.target.set(-261, 5.6, 0);
      orbitControls.update();
      orbitControls.maxPolarAngle = Math.PI;
      orbitControls.minPolarAngle = 0.3;
      orbitControls.maxDistance = 200;
      orbitControls.minDistance = 1;
    }
    if (name == "arrow-01" || name == "arrow-21") {
      camera.position.set(-8.7, 3.8, 0);
      orbitControls.target.set(0, 3.8, 0);
      orbitControls.update();
      orbitControls.maxPolarAngle = Math.PI;
      orbitControls.minPolarAngle = 0.3;
      orbitControls.maxDistance = 200;
      orbitControls.minDistance = 1;
    }
    if (name == "arrow-12" || name == "arrow-32") {
      camera.position.set(-0.5, 22.5, 9.0);
      orbitControls.target.set(-3.5, 22.5, 6.0);
      orbitControls.update();
      orbitControls.maxPolarAngle = Math.PI;
      orbitControls.minPolarAngle = 0;
      orbitControls.maxDistance = 50;
      orbitControls.minDistance = 1;
    }
    if (name == "arrow-23" || name == "arrow-43") {
      camera.position.set(0, 40.5, 2);
      orbitControls.target.set(0, 40.5, 9);
      orbitControls.update();
      orbitControls.maxPolarAngle = Math.PI;
      orbitControls.minPolarAngle = 0;
      orbitControls.maxDistance = 50;
      orbitControls.minDistance = 1;
    }
    if (name == "arrow-34" || name == "arrow-54") {
      camera.position.set(3.9, 59.25, 3.7);
      orbitControls.target.set(7.5, 59.25, 7.4);
      orbitControls.update();
      orbitControls.maxPolarAngle = Math.PI;
      orbitControls.minPolarAngle = 0;
      orbitControls.maxDistance = 50;
      orbitControls.minDistance = 1;
    }
    if (name == "arrow-45" || name == "arrow-65") {
      camera.position.set(6.8, 77.25, 0);
      orbitControls.target.set(11.4, 77.25, 0);
      orbitControls.update();
      orbitControls.maxPolarAngle = Math.PI;
      orbitControls.minPolarAngle = 0;
      orbitControls.maxDistance = 50;
      orbitControls.minDistance = 1;
    }
    if (name == "arrow-56" || name == "arrow-76") {
      camera.position.set(5.3, 95.25, -5.0);
      orbitControls.target.set(8.5, 95.25, -8.5);
      orbitControls.update();
      orbitControls.maxPolarAngle = Math.PI;
      orbitControls.minPolarAngle = 0;
      orbitControls.maxDistance = 50;
      orbitControls.minDistance = 1;
    }
    if (name == "arrow-67" || name == "arrow-87") {
      camera.position.set(0, 115.25, -8.0);
      orbitControls.target.set(0, 115.25, -11);
      orbitControls.update();
      orbitControls.maxPolarAngle = Math.PI;
      orbitControls.minPolarAngle = 0;
      orbitControls.maxDistance = 50;
      orbitControls.minDistance = 1;
    }
    if (name == "arrow-78" || name == "arrow-98") {
      camera.position.set(-5.2, 133.25, -5.3);
      orbitControls.target.set(-9, 133.25, -9);
      orbitControls.update();
      orbitControls.maxPolarAngle = Math.PI;
      orbitControls.minPolarAngle = 0;
      orbitControls.maxDistance = 50;
      orbitControls.minDistance = 1;
    }
    if (name == "arrow-89") {
      camera.position.set(-7.5, 152.65, 0);
      orbitControls.target.set(-13, 152.65, 0);
      orbitControls.update();
      orbitControls.maxPolarAngle = Math.PI;
      orbitControls.minPolarAngle = 0;
      orbitControls.maxDistance = 50;
      orbitControls.minDistance = 1;
    }
  }

  // function moveCamera(delta) {
  //   if (levelNumber == 0) {
  //     // camera.position.lerp(new THREE.Vector3(-53, 2.5, 0), 0.1);
  //   }
  // }

  let cardNumber = 0;
  function changeCardState() {
    if (levelNumber == 0) {
      videoState.set(true);
    } else {
      cardState.set(true);
    }
  }

  let cameraPosition;
  function getCameraPosition() {
    cameraPosition =
      camera.position.x + ", " + camera.position.y + ", " + camera.position.z;
  }

  let cardImageURL;
  function showCard(name) {
    if (name == "plus-1") {
      cardImageURL =
        "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/GF_04_NEW_575x435.jpg?v=1663882096155";
      cardState.set(true);
    }
    if (name == "plus-2") {
      cardImageURL =
        "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/GF_01_NEW_575x435.jpg?v=1663880460357";
      cardState.set(true);
    }
    if (name == "plus-3") {
      cardImageURL =
        "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/GF_08_NEW_575x435.jpg?v=1663880460176";
      cardState.set(true);
    }
    if (name == "plus-4") {
      cardImageURL =
        "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/GF_09_NEW_575x435.jpg?v=1663880460272";
      cardState.set(true);
    }
    if (name == "plus-5") {
      cardImageURL =
        "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/GF_06_NEW_575%D1%87435.jpg?v=1663883104418";
      cardState.set(true);
    }
    if (name == "plus-6") {
      cardImageURL =
        "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/GF_02_NEW_575x435.jpg?v=1663880460603";
      cardState.set(true);
    }
    if (name == "plus-7") {
      cardImageURL =
        "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/GF_07_575x435.jpg?v=1663880460427";
      cardState.set(true);
    }
  }

  // let text1 = `Кожаная сумка с прорезиненным ремнем.
  // Цвет: черный
  // Размер: one size
  // Возможно кастомизировать.`
</script>


<canvas bind:this={appCanvas} style="position: absolute; top: 0; left: 0; width: {width}px; height: {height}px; z-index: -1; " ></canvas>

<!-- <div class="buttonsContainer">
<button class="{btn0class}" bind:this={btn0} on:click={updateLevelNumber}>
0
</button>
<button class="{btn1class}" bind:this={btn1} on:click={updateLevelNumber}>
1
</button>
<button class="{btn2class}" bind:this={btn2} on:click={updateLevelNumber}>
2
</button>
<button class="{btn3class}" bind:this={btn3} on:click={updateLevelNumber}>
3
</button>
<button class="{btn4class}" bind:this={btn4} on:click={updateLevelNumber}>
4
</button>
<button class="{btn5class}" bind:this={btn5} on:click={updateLevelNumber}>
5
</button>
<button class="{btn6class}" bind:this={btn6} on:click={updateLevelNumber}>
6
</button>
<button class="{btn7class}" bind:this={btn7} on:click={updateLevelNumber}>
7
</button>
<button class="{btn8class}" bind:this={btn8} on:click={updateLevelNumber}>
8
</button>
<button class="{btn9class}" bind:this={btn9} on:click={updateLevelNumber}>
9
</button>
<button class="{btn9class}" style="width: 200px; height: 200px;" bind:this={btn9} on:click={getCameraPosition}>
{cameraPosition}
</button>
</div> -->

<!-- <div class="menuContainer">
<button class="button" style="width: 100px; height: 100px;" on:click={()=>{window.open("https://happynumbers.store")}}>
<h2 style="font-size: 50px;">+</h2>
</button>
</div> -->

{#if $cardState}
<Card url="{cardImageURL}" />
{/if}
{#if $videoState}
<Video />
{/if}

<video id="video" loop crossorigin="anonymous" playsinline style="display:none" muted>
        <source src="https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/Happy%20numbers%20INTRO.mp4?v=1660990414112" type="video/mp4" />
    </video>
<!-- <div id="card">
<h2><b>HOW TO PLAY</b></h2>
<p>
<br>
<b>WASD</b> - move<br>
<b>SPACE</b> - jump<br>
<b>LOOK</b> - mouse<br>
</p>
<button id="button">
CLICK TO START
</button>
</div> -->


<style>
  canvas {
    filter: contrast(1.05);
  }
  .buttonsContainer {
    position: absolute;
    top: 0;
    left: 0;
    margin: 10px;
    display: flex;
    flex-direction: column;
    z-index: 0;
  }

  .button {
    width: 40px;
    height: 40px;
    background: rgba(255, 255, 255, 0.2);
    margin: 10px;
    color: black;
    border: 1px solid black;
    backdrop-filter: blur(42px);
    -webkit-backdrop-filter: blur(42px);
    cursor: pointer;

    font-weight: 900;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  .button:hover {
    background: black;
    color: white;
    box-shadow: 5px 5px 0 cyan;
    transform: scale(1.2);
  }

  .selectedButton {
    width: 40px;
    height: 40px;
    margin: 10px;
    background: black;
    color: white;
    border: 1px solid black;
    box-shadow: 5px 5px 0 cyan;
    cursor: pointer;

    font-weight: 900;
    transform: scale(1.2);
  }

  .menuContainer {
    position: absolute;
    bottom: 20px;
    left: calc(50% - 20px);
  }
</style>
